// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import categoryListingStyles from "@steiner/App/SharedStyles/CategoryListingStyles";
import { allCategoriesStyles } from "@steiner/App/Widgets/AllCategories/AllCategories";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

allCategoriesStyles.categoryItem = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `,
};

allCategoriesStyles.innerContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

allCategoriesStyles.categoryImageItem = {
    css: css`
        justify-content: center;
    `,
};

allCategoriesStyles.categoryImage = {
    width: "124px",
    height: "124px",
    css: css`
        img {
            aspect-ratio: 1 / 1;
        }
    `,
};

allCategoriesStyles.categoryNameLinkItem = {
    css: css`
        text-align: center;
    `,
};
allCategoriesStyles.carouselSlidesContainer = {
    css: css`
        .swiper-slide {
            max-width: 124px;
            border-right: 1px solid ${color("common.border")};
            padding-right: 24px;
        }
    `,
};

allCategoriesStyles.categoryNameLink = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.semiBold,
        lineHeight: "19px",
        css: css`
            text-align: center;
            ${ellipsis(3)}
        `,
    },
};
